import { useState } from "react";
import GenericSelectableTable from "../selectableTable";
import { Link } from "react-router-dom";
import { NXEyes } from "../../icons";
import { useDeleteConfirmation } from "../common";
import PurchaseView from "./PurchaseView";



interface TableProps {
  data: any;
  refresh:()=>void;
}

function PurchaseTable({ data, refresh }: TableProps) {

  const [purchaseView, setPurchaseView] = useState<any>(null)

  const { handleDelete } = useDeleteConfirmation()

  const columns = [
    {
      header: "ID",
      key: "id",
      render: (item: any) => (
        <Link to={item.id}>
          <p>{item.id}</p>
          <p className="text-sm font-normal text-base-300 mt-1">#ID{item.id}</p>
        </Link>
      ),
    },
    {
      header: "Supplier",
      key: "supplier_name",
    },
    {
      header: "Destination",
      key: "destination_name",
    },

    {
      header: "Status",
      key: "status",
    },
    {
      header: "Expected Delivery Date",
      key: "expected_delivery_date",
    },
    {
      header: "Created by",
      key: "created_by_name",
    },
    {
      header: "Total cost",
      key: "total_cost",
      render: (item:any)=>(
        <div>
            ${item.total_cost}
        </div>
      )
    },
    { header: "Action", key: "", render: (item: any)=>(
      <div className="flex gap-1 items-center">
        <button onClick={() => setPurchaseView(item)}>
          <NXEyes className="text-primary-400" />
        </button>
        {/* <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.id,
              "Purchase",
              api.deletePurchase,
              refresh
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
        <button className="p-1" onClick={(e: any) => setEdit(item)}>
          <NXEditPen />
        </button> */}
      </div>
    )}
  ];

  return (
    <div className="relative overflow-x-auto">
      <GenericSelectableTable
        columns={columns}
        data={data?.results || []}
      />
      <PurchaseView instance={purchaseView} isOpen={purchaseView ? true : false} onClose={()=>setPurchaseView(!purchaseView)} refresh={refresh} />
    </div>
  );
}

export default PurchaseTable;
